import React from "react";

function TooltipContent({ active, payload, label, prefix, suffix }) {
  const tooltipStyle = {
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  };

  if (active) {
    let value = "";
    let style = {};

    if (payload && payload.length > 0) {
      value = payload[0].value.toFixed(2);
      if (payload[0].value < 0) {
        style = {
          color: "red"
        };
      }
    }

    return (
      <div className="recharts-default-tooltip" style={tooltipStyle}>
        {label}:{" "}
        <span style={style}>
          {prefix}
          {value}
          {suffix}
        </span>
      </div>
    );
  }

  return null;
}

export default TooltipContent;



// WEBPACK FOOTER //
// ./src/components/analysis/tooltip-content.js